import React from 'react';

const PercentGreenStonji: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="80" height="80" transform="translate(0.25)" fill="#00A868" />
      <path
        d="M65.4912 17.2554C66.8719 17.2554 67.9912 16.1361 67.9912 14.7554C67.9912 13.3747 66.8719 12.2554 65.4912 12.2554C64.1105 12.2554 62.9912 13.3747 62.9912 14.7554C62.9912 16.1361 64.1105 17.2554 65.4912 17.2554Z"
        fill="#20252A"
      />
      <path
        d="M15.0083 67.7448C16.389 67.7448 17.5083 66.6255 17.5083 65.2448C17.5083 63.864 16.389 62.7448 15.0083 62.7448C13.6276 62.7448 12.5083 63.864 12.5083 65.2448C12.5083 66.6255 13.6276 67.7448 15.0083 67.7448Z"
        fill="#20252A"
      />
      <path
        d="M63.7385 12.9756L13.2412 63.4729L16.7767 67.0084L67.2741 16.5111L63.7385 12.9756Z"
        fill="#20252A"
      />
      <path
        d="M60.2388 44.9686C58.2559 44.9686 56.3177 45.5565 54.6691 46.6582C53.0204 47.7598 51.7353 49.3256 50.9765 51.1575C50.2177 52.9894 50.0192 55.005 50.406 56.9498C50.7929 58.8945 51.7477 60.681 53.1498 62.0831C54.5519 63.4851 56.3383 64.44 58.2831 64.8268C60.2278 65.2136 62.2436 65.0151 64.0755 64.2563C65.9074 63.4975 67.4731 62.2124 68.5747 60.5638C69.6763 58.9151 70.2643 56.9769 70.2643 54.9941C70.2643 52.3352 69.2081 49.7852 67.328 47.9051C65.4479 46.0249 62.8977 44.9686 60.2388 44.9686ZM60.2388 59.9536C59.2577 59.9545 58.2985 59.6645 57.4823 59.12C56.6661 58.5756 56.0296 57.8011 55.6535 56.895C55.2774 55.9888 55.1786 54.9914 55.3695 54.029C55.5603 53.0667 56.0323 52.1827 56.7258 51.4886C57.4192 50.7946 58.3031 50.3216 59.2653 50.1299C60.2275 49.9382 61.225 50.0361 62.1315 50.4114C63.038 50.7866 63.8129 51.4223 64.3581 52.238C64.9032 53.0537 65.1942 54.0129 65.1942 54.9941C65.1942 56.3087 64.6721 57.5695 63.7429 58.4995C62.8138 59.4295 61.5534 59.9524 60.2388 59.9536Z"
        fill="white"
      />
      <path
        d="M20.2656 15.0116C18.2828 15.0116 16.3444 15.5996 14.6957 16.7012C13.047 17.8028 11.7621 19.3687 11.0033 21.2006C10.2445 23.0325 10.0461 25.0481 10.4329 26.9928C10.8197 28.9375 11.7745 30.724 13.1766 32.1261C14.5787 33.5282 16.365 34.483 18.3097 34.8698C20.2544 35.2567 22.2703 35.0582 24.1022 34.2994C25.9341 33.5406 27.4997 32.2555 28.6013 30.6068C29.7029 28.9581 30.2909 27.0199 30.2909 25.0371C30.2909 22.3782 29.2348 19.8282 27.3546 17.9481C25.4745 16.068 22.9245 15.0116 20.2656 15.0116ZM20.2656 29.9966C19.2847 29.9966 18.3259 29.7059 17.5102 29.1609C16.6946 28.6159 16.0588 27.8412 15.6834 26.935C15.308 26.0287 15.2099 25.0316 15.4013 24.0695C15.5926 23.1074 16.0651 22.2235 16.7587 21.5299C17.4523 20.8363 18.336 20.3641 19.298 20.1727C20.2601 19.9814 21.2572 20.0794 22.1635 20.4548C23.0698 20.8302 23.8445 21.4661 24.3895 22.2817C24.9344 23.0973 25.2252 24.0562 25.2252 25.0371C25.2252 25.6884 25.0969 26.3332 24.8477 26.935C24.5984 27.5367 24.2331 28.0835 23.7726 28.544C23.312 29.0046 22.7652 29.3699 22.1635 29.6191C21.5618 29.8684 20.917 29.9966 20.2656 29.9966Z"
        fill="white"
      />
    </svg>
  );
};

export default PercentGreenStonji;
